module.exports = __webpack_public_path__ + "fa-brands-400.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = 20
// module chunks = 0